import useGlobalConfig from "@/store/global";

const Octagam = () => {
  const { themeColor } = useGlobalConfig();

  return (
    <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
      <div className="my-6 border-b-2 border-dotted" 
           style={{ borderColor: themeColor }} />

      <div className="font-bold">IMPORTANT SAFETY INFORMATION</div>

      <div className="mt-6 p-2 border border-black">
        <p className="font-bold">WARNING: THROMBOSIS, RENAL DYSFUNCTION, AND ACUTE RENAL FAILURE</p>
        
        <p className="mt-2 italic">
          Please see octagam® 5% and octagam® 10% full Prescribing Information for complete Boxed Warnings and other important information.
        </p>

        <ul className="list-disc ml-4 mt-4 font-bold">
          <li className="my-2">
            Thrombosis may occur with immune globulin intravenous (IGIV) products, including octagam® 5% and octagam® 10% liquid preparations. Risk factors may include: advanced age, prolonged immobilization, hypercoagulable conditions, history of venous or arterial thrombosis, use of estrogens, indwelling vascular catheters, hyperviscosity, and cardiovascular risk factors.
          </li>
          <li className="my-2">
            Renal dysfunction, acute renal failure, osmotic nephrosis, and death may occur in predisposed patients with IGIV products, including octagam® 5% and octagam® 10% liquid preparations. Patients predisposed to renal dysfunction include those with a degree of pre-existing renal insufficiency, diabetes mellitus, age greater than 65, volume depletion, sepsis, paraproteinemia, or patients receiving known nephrotoxic drugs. Renal dysfunction and acute renal failure occur more commonly with IGIV products containing sucrose. Octagam® 5% and octagam® 10% liquid preparations do not contain sucrose.
          </li>
          <li className="my-2">
            For patients at risk of thrombosis, renal dysfunction, or acute renal failure administer octagam® 5% or octagam® 10% liquid preparations at the minimum dose and infusion rate practicable. Ensure adequate hydration in patients before administration. Monitor for signs and symptoms of thrombosis and assess blood viscosity in patients at risk for hyperviscosity.
          </li>
        </ul>
      </div>

      <div className="mt-6">
        <p className="my-2 font-bold">Contraindications for octagam® 5%</p>
        <p className="my-2">
          Octagam® 5% liquid is contraindicated in patients who have acute severe hypersensitivity reactions to human immunoglobulin; in IgA-deficient patients with antibodies against IgA and history of hypersensitivity; in patients with acute hypersensitivity reaction to corn. Octagam® 5% liquid contains maltose, a disaccharide which is derived from corn. Patients known to have corn allergies should avoid using octagam® 5% liquid.
        </p>
      </div>

      <div className="mt-6">
        <p className="my-2 font-bold">Warnings and Precautions for octagam® 5%</p>
        <ul>
          <li className="my-2">Monitor renal function, including blood urea nitrogen and serum creatinine, and urine output in patients at risk of developing acute renal failure.</li>
          <li className="my-2">Falsely elevated blood glucose readings may occur during and after the infusion of octagam® 5% liquid with some glucometer and test strip systems.</li>
          <li className="my-2">Hyperproteinemia, increased serum osmolarity, and hyponatremia may occur in patients receiving IGIV therapy. Aseptic meningitis syndrome has been reported with octagam® 5% liquid and other lGlV treatments, especially with high doses or rapid infusion.</li>
          <li className="my-2">Hemolytic anemia can develop subsequent to IGIV therapy due to enhanced RBC sequestration.</li>
          <li className="my-2">IGIV recipients should be monitored for pulmonary adverse reactions such as transfusion-related acute lung injury (TRALI).</li>
          <li className="my-2">The product is made from human plasma and may contain infectious agents, e.g. viruses and, theoretically, the Creutzfeldt-Jakob disease agent.</li>
        </ul>
      </div>

      <div className="mt-6">
        <p className="my-2 font-bold">Adverse Reactions for octagam® 5%</p>
        <p className="my-2">
          The most serious adverse reactions observed with octagam® 5% liquid treatment have been immediate anaphylactic reactions, aseptic meningitis, and hemolytic anemia.
          The most common adverse reactions with an incidence of >5% during a clinical trial were headache and nausea.
        </p>
      </div>

      <div className="mt-6">
        <p className="my-2 font-bold">Dosing and Administration for octagam® 10% in Patients with DM</p>
        <p className="my-2">
          Patients with DM are at increased risk for thromboembolic events; monitor carefully and do not exceed an infusion rate of 0.04 mL/kg/min.
        </p>
      </div>

      <div className="mt-6">
        <p className="my-2 font-bold">Contraindications for octagam® 10%</p>
        <p className="my-2">
          Octagam® 10% is contraindicated in patients who have a history of severe systemic hypersensitivity reactions, such as anaphylaxis, to human immunoglobulin. Octagam® 10% contains trace amounts of IgA (average 106 μg/mL in a 10% solution). It is contraindicated in IgA-deficient patients with antibodies against IgA and history of hypersensitivity.
        </p>
      </div>

      <div className="mt-6">
        <p className="my-2 font-bold">Warnings and Precautions for octagam® 10%</p>
        <ul>
          <li className="my-2">IgA-deficient patients with antibodies against IgA are at greater risk of developing severe hypersensitivity and anaphylactic reactions to octagam® 10%. Epinephrine should be available immediately to treat any severe acute hypersensitivity reactions.</li>
          <li className="my-2">Monitor renal function, including blood urea nitrogen and serum creatinine, and urine output in patients at risk of developing acute renal failure.</li>
          <li className="my-2">Falsely elevated blood glucose readings may occur during and after the infusion of octagam® 10% with testing by some glucometers and test strip systems.</li>
          <li className="my-2">Hyperproteinemia, increased serum osmolarity and hyponatremia may occur in patients receiving octagam® 10%.</li>
          <li className="my-2">Hemolysis that is either intravascular or due to enhanced red blood cell sequestration can develop subsequent to octagam® 10% treatments. Risk factors for hemolysis include high doses and non-O-blood group. Closely monitor patients for hemolysis and hemolytic anemia.</li>
          <li className="my-2">Aseptic Meningitis Syndrome may occur in patients receiving octagam® 10%, especially with high doses or rapid infusion. Monitor patients for pulmonary adverse reactions (transfusion-related acute lung injury [TRALI]).</li>
          <li className="my-2">Octagam® 10% is made from human plasma and may contain infectious agents, e.g. viruses and, theoretically, the Creutzfeldt-Jakob disease agent.</li>
        </ul>
      </div>

      <div className="mt-6">
        <p className="my-2 font-bold">Adverse Reactions for octagam® 10%</p>
        <p className="my-2">
          Chronic Immune Thrombocytopenic Purpura (ITP) The most common adverse reactions observed in >5% of clinical study subjects with ITP were headache, fever, and increased heart rate.
        </p>
        <p className="my-2">
          Dermatomyositis (DM) The most common adverse reactions observed in > 5% of clinical study subjects with DM were headache, fever, nausea, vomiting, increased blood pressure, chills, musculoskeletal pain, increased heart rate, dyspnea, and infusions site reactions.
        </p>
      </div>

      <div className="mt-6">
        <p className="my-2">
          Please see&nbsp;
          <a
            target="_blank"
            href="/octagam5-full-prescribing-information.pdf"
            className="!text-sky-700 hover:underline"
            rel="noopener noreferrer"
          >
            Full Prescribing Information
          </a>
          &nbsp;for octagam® 5% and octagam® 10%.
        </p>
      </div>
    </div>
  );
};

export default Octagam;
